<template>
  <div class="escort-page">
    <!-- 消息提示 -->
    <div class="escort-message flex-rowl">
      <div class="escort-message-icon hot"></div>
      <div class="escort-message-content">
        <div class="escort-message-content-item">有待处理的陪护订单</div>
      </div>
    </div>

    <!-- 筛选 -->
    <div class="filter-wrap">
      <div class="search-wrap flex-rowl">
        <span class="search-icon" @click="handleSearch"
          ><img src="../assets/images/search-icon.png" alt=""
        /></span>
        <input
          type="text"
          placeholder="请输入请输入目的地名称关键词"
          v-model="params.keyword"
          @keyup.enter="handleSearch"
        />
      </div>
      <div class="dropdown-wrap">
        <van-dropdown-menu>
          <van-dropdown-item
            v-model="params.servicetype"
            :options="option1"
            @change="handleDropdownOpenedType"
          />
          <van-dropdown-item
            v-model="params.service_order_status"
            :options="option2"
            @change="handleDropdownOpenedState"
          />
        </van-dropdown-menu>
      </div>
    </div>

    <!-- 服务订单 -->
    <div class="common-list-wrap">
      <div
        class="common-list-content"
        ref="escortOrderList"
        @scroll="handleScroll"
        v-if="dataList.length > 0 && !isLoading"
      >
        <van-pull-refresh v-model="isRefresh" @refresh="onRefresh">
          <div
            class="common-list-item"
            v-for="(item, index) in dataList"
            :key="index"
             @click="handleDetail(item)"
          >
            <div class="order-info-wrap flex-rowl">
              <div class="order-icon"></div>
              <div class="order-content">
                <p>订单编号：</p>
                <p class="flex-rowl">
                  {{ item.order_id }}
                  <span
                    class="copy-icon"
                    @click.stop="copyToClipboard(item.order_id)"
                  ></span>
                </p>
                <p class="txt">{{ formatTime(item.create_time) }}</p>
                <div class="label">服务内容：{{ item.servicecontstr }}</div>
              </div>
            </div>
            <div
              class="user-info-wrap"
              v-if="item.park_catering_service_order_obj"
            >
              <div class="name" v-if="false">
                对象：{{
                  item.park_catering_service_order_obj
                    ? item.park_catering_service_order_obj.truename
                    : ""
                }}
              </div>
              <div class="txt" v-if="false">
                <p>
                  <span v-if="item.province2str"
                    >{{ item.province2str ? item.province2str : "" }}，</span
                  ><span v-if="item.city2str"
                    >{{ item.city2str ? item.city2str : "" }}，</span
                  ><span v-if="item.area2str">{{
                    item.area2str ? item.area2str : ""
                  }}</span>
                </p>
                <p>{{ item.addr2 }}</p>
              </div>

              <div class="state">
                <p>
                  服务预约时间：{{
                    item.servicecont == 3 ||
                    item.servicecont == 11 ||
                    item.servicecont == 13
                      ? formatTime(item.create_time)
                      : formatTime(item.asktime)
                  }}
                </p>
                <p>
                  状态：<span class="blue">{{
                    item.service_order_statusstr
                  }}</span>
                </p>
              </div>
              <div class="price-block">
                <div class="price-wrap">
                  <p>
                    基础费用：<span :class="{ red: !item.timeoutprice }">{{
                      item.timeoutprice ? "¥" + item.timeoutprice : "待核算"
                    }}</span>
                  </p>
                  <p>
                    支付状态：<span
                      :class="{ red: item.isreturn != 2 }"
                      v-if="item.isreturn == 1"
                      >{{
                        item.returncheck == 1
                          ? "已退款"
                          : item.returncheck == 2
                          ? "退款，不同意"
                          : "退款中"
                      }}</span
                    >
                    <span :class="{ red: item.ispay != 1 }" v-else>{{
                      item.ispaystr ? item.ispaystr : "待支付"
                    }}</span>
                    <span
                      class="management-btn"
                      v-if="
                        item.service_order_status == 8 &&
                        item.ispay == 1 &&
                        item.isreturn != 1
                      "
                      @click.stop="handleShowManagePopup(item, 2)"
                      >管理</span
                    >
                  </p>
                  <p>
                    支付方式：<span v-if="item.paytype">{{
                      item.ispaystr
                        ? item.paytype == 1
                          ? item.paytypestr
                          : item.paytypestr +
                            "，" +
                            (item.getmancardno ? "已确认" : "待确认")
                        : ""
                    }}</span
                    ><span class="red" v-else>无</span>
                  </p>
                </div>
                <!-- 超时收费 -->
                <div class="price-wrap">
                  <p>
                    超时费用：<span
                      :class="{
                        red: !item.park_catering_service_order_fee_obj.fee,
                      }"
                      >{{
                        item.park_catering_service_order_fee_obj.fee
                          ? "¥" + item.park_catering_service_order_fee_obj.fee
                          : "无"
                      }}</span
                    >
                  </p>
                  <p>
                    支付状态：<span
                      :class="{
                        red:
                          item.park_catering_service_order_fee_obj.paystate !=
                          1,
                      }"
                      >{{
                        item.park_catering_service_order_fee_obj.paystate == 1
                          ? "已支付"
                          : item.park_catering_service_order_fee_obj.paystate ==
                            2
                          ? "待支付"
                          : "无"
                      }}</span
                    >
                  </p>
                  <p>
                    支付方式：<span
                      v-if="item.park_catering_service_order_fee_obj.paytype"
                      >{{
                        item.park_catering_service_order_fee_obj.paytype == 1
                          ? "线上支付"
                          : "线下现金结算" +
                            "，" +
                            (item.park_catering_service_order_fee_obj.hrcode
                              ? "已确认"
                              : "待确认")
                      }}</span
                    ><span class="red" v-else>无</span>
                  </p>
                </div>
                <!-- 额外交通费用 -->
                <div class="price-wrap">
                  <p>
                    额外交通费用：<span
                      :class="{
                        red: !item.park_catering_service_order_feetraffic_obj
                          .fee,
                      }"
                      >{{
                        item.park_catering_service_order_feetraffic_obj.fee
                          ? "¥" +
                            item.park_catering_service_order_feetraffic_obj.fee
                          : "无"
                      }}</span
                    >
                  </p>
                  <p>
                    支付状态：<span
                      :class="{
                        red:
                          item.park_catering_service_order_feetraffic_obj
                            .paystate != 1,
                      }"
                      >{{
                        item.park_catering_service_order_feetraffic_obj
                          .paystate == 1
                          ? "已支付"
                          : item.park_catering_service_order_feetraffic_obj
                              .paystate == 2
                          ? "待支付"
                          : "无"
                      }}</span
                    >
                  </p>
                  <p>
                    支付方式：<span
                      v-if="
                        item.park_catering_service_order_feetraffic_obj.paytype
                      "
                      >{{
                        item.park_catering_service_order_feetraffic_obj
                          .paytype == 1
                          ? "线上支付"
                          : "线下现金结算" +
                            "，" +
                            (item.park_catering_service_order_feetraffic_obj
                              .hrcode
                              ? "已确认"
                              : "待确认")
                      }}</span
                    ><span class="red" v-else>无</span>
                  </p>
                </div>
                <!-- 其他额外费用 -->
                <div class="price-wrap">
                  <p>
                    其他额外费用：<span
                      :class="{
                        red: !item.park_catering_service_order_feeother_obj.id,
                      }"
                      >{{
                        item.park_catering_service_order_feeother_obj.id
                          ? "¥" +
                            item.park_catering_service_order_feeother_obj.fee
                          : "无"
                      }}</span
                    >
                    <span
                      v-if="
                        item.park_catering_service_order_feeother_obj.feetype
                      "
                      >{{
                        item.park_catering_service_order_feeother_obj.feetype ==
                        1
                          ? "药品购买费用"
                          : item.park_catering_service_order_feeother_obj
                              .feetype == 2
                          ? "挂号费"
                          : item.park_catering_service_order_feeother_obj
                              .feetype == 3
                          ? "检查预约付费"
                          : item.park_catering_service_order_feeother_obj
                              .feetype == 4
                          ? "住院押金"
                          : "其它额外费用"
                      }}</span
                    >
                  </p>
                  <p>
                    支付状态：<span
                      :class="{
                        red:
                          item.park_catering_service_order_feeother_obj
                            .paystate != 1,
                      }"
                      >{{
                        item.park_catering_service_order_feeother_obj
                          .paystate == 1
                          ? "已支付"
                          : item.park_catering_service_order_feeother_obj
                              .paystate == 2
                          ? "待支付"
                          : "无"
                      }}</span
                    >
                  </p>
                  <p>
                    支付方式：<span
                      v-if="
                        item.park_catering_service_order_feeother_obj.paytype
                      "
                      >{{
                        item.park_catering_service_order_feeother_obj.paytype ==
                        1
                          ? "线上支付"
                          : "线下现金结算" +
                            "，" +
                            (item.park_catering_service_order_feeother_obj
                              .hrcode
                              ? "已确认"
                              : "待确认")
                      }}</span
                    ><span class="red" v-else>无</span>
                  </p>
                </div>
              </div>
            </div>
            <div
              class="operation-wrap flex-between"
            >
              <div class="operation-item flex-rowc">订单服务管理</div>
              <div class="operation-item flex-rowc">查看订单详情</div>
            </div>
          </div>
        </van-pull-refresh>

        <div class="common-no-more flex-rowc" v-if="hasMore">
          暂无更多数据...
        </div>
      </div>
      <!-- 加载提示 -->
      <div class="common-loading-wrap flex-rowc" v-if="isLoading">
        <van-loading type="spinner" vertical>加载中...</van-loading>
      </div>
      <div
        class="common-no-data flex-rowc"
        v-if="dataList.length == 0 && !isLoading"
      >
        <van-empty description="暂无数据" />
      </div>
    </div>
  </div>
</template>
  
  <script>
import Clipboard from "clipboard";
import { getCommunityServiceOrderList } from "../api/api";
export default {
  name: "Eescort",
  data() {
    return {
      option1: [
        { text: "服务类型", value: "" },
        { text: "常规陪护服务", value: 1 },
        { text: "长期居家护理服务", value: 2 },
        { text: "其他陪护服务", value: 3 },
      ],
      option2: [
        { text: "服务状态", value: "" },
        { text: "待接单", value: "1" },
        { text: "已接单，待付款", value: "2" },
        { text: "已接单，已付款", value: "3" },
        { text: "服务中", value: "4" },
        { text: "服务已完成（待评价）", value: "5" },
        { text: "服务已完成（已评价）", value: "6" },
        { text: "服务取消审核中", value: "7" },
        { text: "服务已取消", value: "8" },
      ],
      params: {
        pageindex: 1,
        pagesize: 10,
        keyword: "",
        servicetype: "", // 订单服务类型 =1=常规陪护服务|2=长期居家护理服务|3=其他陪护服务|
        service_order_status: "",
        get_staff_id: "",
      },
      dataList: [], //
      totalPage: 1, // 总页数
      isLoading: true, // 是否正在加载
      hasMore: false, // 是否还有更多数据
      isLoadingMore: false, // 新增加载状态锁
      isRefresh: false, // 是否正在刷新
    };
  },
  async mounted() {
    // 查看USERINFO.userFunction
    if (this.$store.state.USERINFO.userFunction) {
      this.params.get_staff_id =
        this.$store.state.USERINFO.userFunction.dispatch_staff_id;
    }
    this.getCommunityServiceOrderList();
  },
  methods: {
    // 定义时间格式化方法
    formatTime(timeStr) {
      if (!timeStr) return "";
      return timeStr.replace("T", " ");
    },

    // 封装转换数组为对象的函数
    getFirstItemOrEmptyArray(arr) {
      return Array.isArray(arr) && arr.length > 0 ? arr[0] : {};
    },

    // 获取街道列表
    async getCommunityServiceOrderList() {
      try {
        const res = await getCommunityServiceOrderList(this.params);
        if (res.list) {
          res.list.forEach((v) => {
            // 使用封装函数转换数组为对象
            v.park_catering_service_order_fee_obj =
              this.getFirstItemOrEmptyArray(v.park_catering_service_order_fee);
            v.park_catering_service_order_feetraffic_obj =
              this.getFirstItemOrEmptyArray(
                v.park_catering_service_order_feetraffic
              );
            v.park_catering_service_order_feeother_obj =
              this.getFirstItemOrEmptyArray(
                v.park_catering_service_order_feeother
              );
          });
          this.dataList = this.dataList.concat(res.list);
          this.totalPage = res.total;
        }
      } catch (error) {
        console.error("获取街道列表失败", error);
      } finally {
        // 等待 800 毫秒后关闭加载提示
        await new Promise((resolve) => setTimeout(resolve, 500));
        this.isLoading = false;
      }
    },

    // 搜索
    handleSearch() {
      this.isLoading = true;
      this.params.pageindex = 1;
      this.dataList = [];
      this.getCommunityServiceOrderList();
    },

    // 下拉选择
    handleDropdownOpenedType(e) {
      this.params.servicetype = e;
      this.isLoading = true;
      this.params.pageindex = 1;
      this.dataList = [];
      this.getCommunityServiceOrderList();
    },

    // 下拉选择
    handleDropdownOpenedState(e) {
      this.params.service_order_status = e;
      this.isLoading = true;
      this.params.pageindex = 1;
      this.dataList = [];
      this.getCommunityServiceOrderList();
    },

    // 下拉刷新
    async onRefresh() {
      // 等待 800 毫秒后关闭加载提示
      await new Promise((resolve) => setTimeout(resolve, 500));
      this.isRefresh = false;
      this.params.pageindex = 1;
      this.params.keyword = "";
      this.params.servicetype = "";
      this.params.service_order_status = "";
      this.dataList = [];

      this.getCommunityServiceOrderList();
    },

    // 处理滚动事件
    handleScroll() {
      const { scrollTop, scrollHeight, clientHeight } =
        this.$refs.escortOrderList;
      let { dataList, totalPage, isLoadingMore } = this;
      if (isLoadingMore || dataList.length >= totalPage) return;
      // 当滚动到底部 20px 范围内时触发加载
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        this.hasMore = true;
        this.params.pageindex++;
        this.isLoadingMore = true; // 开始加载，设置锁
        this.getCommunityServiceOrderList().finally(() => {
          this.isLoadingMore = false; // 加载完成，释放锁
        });
      }
    },

    // 复制
    copyToClipboard(text) {
      const tempElement = document.createElement('button');
      tempElement.setAttribute('data-clipboard-text', text);
      const clipboard = new Clipboard(tempElement);

      clipboard.on('success', () => {
        this.$toast.success('复制成功');
        clipboard.destroy();
      });

      clipboard.on('error', () => {
        this.$toast.fail('复制失败');
        clipboard.destroy();
      });

      // 手动触发复制操作
      tempElement.click();
    },

    handleDetail(item) {
      if (item.servicecont == 3) {
        // 代拿报告
        this.$router.push({
          name: "OrderReportDetailDispatch",
          query: { id: item.id },
        });
      } else if (item.servicecont == 11) {
        // 代配药
        this.$router.push({
          name: "MedicineDispatchDetailDispatch",
          query: { id: item.id },
        });
      } else if (item.servicecont == 12) {
        // 代问诊
        this.$router.push({
          name: "InquiryAgencyDetailDispatch",
          query: { id: item.id },
        });
      } else if (item.servicecont == 13) {
        // 预约检查
        this.$router.push({
          name: "AppointmentCheckDetailDispatch",
          query: { id: item.id },
        });
      } else if (item.servicecont == 14) {
        // 代办住院/出院
        this.$router.push({
          name: "InHospitalDetailDispatch",
          query: { id: item.id },
        });
      } else if (item.servicecont == 15) {
        // 代办入院/出院
        this.$router.push({
          name: "InHospitalInDetailDispatch",
          query: { id: item.id },
        });
      } else {
        this.$router.push({
          name: "OrderDetailDispatch",
          query: { id: item.id },
        });
      }
    },
  },
};
</script>
  
  <style scoped lang="less">
.escort-page {
  .escort-message {
    padding: 70px 0 34px;
    box-sizing: border-box;
    width: 620px;
    margin: auto;
    font-size: 36px;
    color: #1e1e1e;
    .escort-message-icon {
      position: relative;
      margin-right: 20px;
      width: 46px;
      height: 37px;
      background: url(../assets/images/message-tip-icon.png) no-repeat center;
      background-size: cover;
      &.hot {
        &::after {
          content: "";
          position: absolute;
          display: inline-block;
          width: 13px;
          height: 13px;
          background: red;
          border-radius: 50%;
          right: -2px;
          top: -2px;
        }
      }
    }
  }
  .search-wrap {
    width: 700px;
    height: 71px;
    background: #ffffff;
    border-radius: 36px;
    margin: auto;
    padding: 0 30px;
    box-sizing: border-box;
    font-size: 32px;
    .search-icon {
      width: 30px;
      height: 30px;
      margin-right: 18px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    input {
      flex: 1;
    }
  }
  /deep/.van-dropdown-item__content {
    max-width: 750px;
    left: 50%;
    transform: translateX(-50%);
  }
  /deep/.van-dropdown-menu__bar {
    background: none;
    box-shadow: none;
  }
  /deep/.van-dropdown-menu__title::after {
    opacity: 1;
    border-color: transparent transparent #333333 #333333;
  }
  /deep/.van-dropdown-menu__title--active::after {
    border-color: transparent transparent currentColor currentColor;
  }
  .dropdown-wrap {
    width: 700px;
    margin: 0 auto 10px;
  }
  .common-list-wrap {
    width: 700px;
    margin: auto;
    .common-list-content {
      margin: auto;
      height: 70vh;
      overflow-y: scroll;
      padding-bottom: 80px;
      box-sizing: border-box;
      // 隐藏滚动条
      &::-webkit-scrollbar {
        display: none;
      }
      .common-list-item {
        width: 100%;
        background: #fff;
        border-radius: 60px;
        padding: 40px 0;
        box-sizing: border-box;
        font-size: 20px;
        align-items: flex-start;
        color: #333333;
        margin-bottom: 30px;
        cursor: pointer;
        .order-info-wrap {
          width: 100%;
          padding: 0 50px;
          align-items: flex-start;
          box-sizing: border-box;
          .order-icon {
            width: 83px;
            height: 50px;
            background: url("../assets/images/order-icon.png") no-repeat center;
            background-size: cover;
            margin-right: 17px;
          }
          .order-content {
            flex: 1;
            p {
              font-size: 36px;
              color: #333333;
              line-height: 46px;
              &.txt {
                font-size: 30px;
                color: #999999;
                margin: 16px 0 19px;
                line-height: 30px;
              }
            }
            .label {
              background: #f5f7fb;
              display: inline-block;
              font-size: 36px;
              color: #2854cb;
              padding: 12px 14px;
              box-sizing: border-box;
            }
            .copy-icon {
              display: inline-block;
              width: 40px;
              height: 43px;
              background: url("../assets/images/copy1-icon.png") no-repeat
                center;
              background-size: cover;
              margin-left: 30px;
            }
          }
        }
        .user-info-wrap {
          padding: 0 50px;
          box-sizing: border-box;
          .name {
            font-size: 32px;
            color: #333333;
            margin: 29px 0 28px;
          }
          .txt {
            // margin: 28px 0 38px;
            font-size: 28px;
            color: #333333;
            p {
              margin-bottom: 12px;
              &:last-child {
                margin-bottom: 0;
              }
            }
          }
          .state {
            margin: 38px auto;
            font-size: 30px;
            color: #333333;
            p {
              margin-bottom: 24px;
              &:last-child {
                margin-bottom: 0;
              }
              .red {
                color: #fe0000;
              }
              .blue {
                color: #2854cb;
              }
            }
          }
          .price-block {
            margin-bottom: 50px;
            .price-wrap {
              margin-bottom: 35px;
              p {
                font-size: 26px;
                margin-bottom: 20px;
                &:last-child {
                  margin-bottom: 0;
                }
                .red {
                  color: #fe0000;
                }
                .blue {
                  color: #2854cb;
                }
                span {
                  margin-right: 40px;
                }
              }
            }
          }
        }
        .operation-wrap {
          padding: 0 28px;
          box-sizing: border-box;
          .operation-item {
            width: 300px;
            height: 90px;
            border-radius: 50px;
            border: 2px solid #000000;
            font-size: 30px;
            color: #333333;
          }
        }
      }
    }
  }
}
</style>